<template lang="pug">
.queue-panel(:class="{'active': showQueuePanel}" )
  .bg(@click="toggleQueuePanel(false)")
  .panel(ref="panel")
    .copy
      .title 展项排号
      .subtitle 特别展项需要排号才能体验哦
    close-btn(@clicked="toggleQueuePanel(false)")
    //.close-btn(@click="toggleQueuePanel(false)")
      img(src="~assets/btn-close.png")
    .tab
    .cards
      queue-card(exhibitId="3")
      queue-card2(exhibitId="4")
      queue-card3(exhibitId="5")
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import QueueCard from '@/components/home/QueueCard'
import QueueCard2 from '@/components/home/QueueCard2'
import QueueCard3 from '@/components/home/QueueCard3'
import Hammer from 'hammerjs'
import gsap from 'gsap'
import CloseBtn from '@/components/wedgits/CloseBtn'
export default {
  name: 'QueuePanel',
  components: { CloseBtn, QueueCard3, QueueCard2, QueueCard },
  props: {},
  data() {
    return {
      lastY: 0,
    }
  },
  computed: {
    ...mapState('app', ['showQueuePanel', 'user']),
  },
  watch: {},
  methods: {
    ...mapMutations('app', ['toggleQueuePanel']),
    init() {
      this.mc = new Hammer(this.$refs.panel)
      this.mc.add(
        new Hammer.Pan({
          direction: Hammer.DIRECTION_VERTICAL,
          threshold: 0,
        })
      )
      this.mc.on('pan', this.onDrag)

      //this.lastX = window.innerWidth - 80
      //this.lastY = window.innerHeight - 80
      //gsap.set(this.$refs.panel, { x: this.lastX, y: this.lastY })
      //this.lastX = this.$refs.btn.getBoundingClientRect().x
      //this.lastY = this.$refs.btn.getBoundingClientRect().y
    },
    onDrag(e) {
      //console.log(e.deltaY)
      let y = this.lastY + e.deltaY
      console.log(y)

      //gsap.set(this.$refs.btn, { x: x, y: y })
      //this.$refs.btn.style.transform = `translate3d(${x}px, ${y}px, 0)`
      //this.$refs.btn.style.left = e.deltaX + 'px'
      //this.$refs.btn.style.top = e.deltaY + 'px'
      if (e.isFinal) {
        this.lastY = y
        //this.snap()
      }
    },
    snap() {
      let snapGap = 60
      let rect = this.$refs.btn.getBoundingClientRect()
      let top = rect.y
      let left = rect.x
      console.log('!!!!!!!', top, left)
      let xmin = Math.min(left, window.innerWidth - left)
      let ymin = Math.min(top, window.innerHeight - top)
      if (xmin < ymin) {
        if (left > window.innerWidth - left) {
          left = window.innerWidth - snapGap
        } else {
          left = snapGap
        }
      } else {
        if (top > window.innerHeight - top) {
          top = window.innerHeight - snapGap
        } else {
          top = snapGap
        }
      }
      left -= rect.width / 2
      top -= rect.height / 2
      this.lastX = left
      this.lastY = top
      console.log(xmin, ymin, left, top)
      gsap.to(this.$refs.btn, {
        x: left,
        y: top,
        duration: 0.5,
        ease: 'power2',
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.queue-panel
  +full
  z-index: 600
  pointer-events: none
  &.active
    pointer-events: all
    .panel
      transform: translateY(0)
    .bg
      pointer-events: all
      background: rgba(0, 0, 0, 0.25)
  .bg
    +full
    background: transparent
    pointer-events: none
  .panel
    pointer-events: all
    transition: all 0.5s $easeOutCubic
    transform: translateY(100%)
    width: 100%
    height: pxToRem(1190)
    position: absolute
    left: 0
    bottom: 0
    background: white
    border-top-left-radius: pxToRem(16)
    border-top-right-radius: pxToRem(16)
    .cards
      position: absolute
      width: 100%
      left: 0
      bottom: 0
      //display: flex
      //align-items: center
      //justify-content: flex-start
      //flex-direction: column
    .tab
      width: pxToRem(120)
      height: pxToRem(8)
      border-radius: pxToRem(6)
      background: $cl-gray
      margin: pxToRem(22) auto 0 auto
    .copy
      position: absolute
      left: pxToRem(35)
      top: pxToRem(49)
      transform: translateZ(20px)
      pointer-events: none
      .title
        font-size: pxToRem(42)
        line-height: pxToRem(50)
        color: black
      .subtitle
        color: $cl-gray
        margin-top: pxToRem(10)
        font-size: pxToRem(30)
    .close-btn
      top: pxToRem(49)
      right: pxToRem(24)
</style>
